import { formatPrice } from './formats';
import { LIST_VIEW_TYPES } from './../constants/list-types';
import STRINGS from './../constants/text-strings';

export const generateSumOfDiscounts = (discounts) => {
    return discounts
        .map((discount) => discount.amount)
        .reduce((total, currentAmount) => {
            return total + currentAmount;
        }, 0);
};

export const getBidCount = (item) => {
    return item && item.bidInformation && item.bidInformation.bidCount > 0
        ? item.bidInformation.bidCount
        : 0;
};

export const getSumOfDiscounts = (item) => {
    const transaction = item.transaction;
    return transaction &&
        transaction.discounts &&
        transaction.discounts.length > 0
        ? generateSumOfDiscounts(transaction.discounts)
        : null;
};

export const getMaxBid = (item) =>
    item.caller && item.caller.maxBid && item.caller.maxBid > 0
        ? item.caller.maxBid
        : null;

export const getTimeLeft = (item) => {
    return item.isActive === true && item.timeLeft && item.timeLeft.timeleft
        ? item.timeLeft.timeleft
        : null;
};

export const isTimeLeftCritical = (item) => {
    return item.timeLeft && item.timeLeft.critical
        ? item.timeLeft.critical
        : false;
};

export const getShippingCost = (item, listViewType) => {
    const translateShippingNames = (name) => {
        const names = {
            Takeaway: 'Avh.',
            TakeawayLong: 'Avhämtning',
            TakeawayOnly: 'Avhämtning',
            SchenkerPrivpak: 'DB Schenker',
            Alternative: 'Annat fraktsätt'
        };
        if (!names[name]) {
            return name;
        }
        if (name === 'Takeaway' && listViewType === LIST_VIEW_TYPES.BASIC) {
            return names['TakeawayLong'];
        }
        return names[name];
    };

    const shouldShowShippingPrice = (shippingItem) =>
        shippingItem.shippingType === 'Takeaway'
            ? ''
            : `: ${formatPrice(shippingItem.shippingCost)}`;
    const getShippingLabelWithPrice = (shippingItem) => {
        return `${translateShippingNames(
            shippingItem.shippingType
        )}${shouldShowShippingPrice(shippingItem)}`;
    };

    return () => {
        const shippingOptions = item.listing.shippingOptions;

        if (item.transaction) {
            // Logic from Areas/MyTradera/Models/ShippingPrice.cs
            const selectedShipping = item.transaction.selectedShipping;
            if (selectedShipping) {
                if (selectedShipping.isTakeaway) {
                    return `${translateShippingNames(
                        'Takeaway'
                    )}: ${formatPrice(item.transaction.selectedShipping.cost)}`;
                }

                if (selectedShipping.isFreeShipping) {
                    return STRINGS.SHIPPING_LABELS.FREE_SHIPPING;
                }
                return `${translateShippingNames(
                    selectedShipping.name
                )}: ${formatPrice(item.transaction.selectedShipping.cost)}`;
            } else {
                /*
                 * @todo: This if should be fixed in the backend.
                 */
                if (shippingOptions.length === 1) {
                    const theOnlyShippingOption =
                        item.listing.shippingOptions[0];
                    return theOnlyShippingOption.shippingType === 'Takeaway'
                        ? STRINGS.SHIPPING_LABELS.TAKEAWAY
                        : formatPrice(theOnlyShippingOption.shippingCost);
                }

                return shippingOptions.map((shippingItem, i) => {
                    return listViewType === LIST_VIEW_TYPES.BASIC ? (
                        <p key={i}>{getShippingLabelWithPrice(shippingItem)}</p>
                    ) : (
                        `${getShippingLabelWithPrice(shippingItem)}${
                            i < shippingOptions.length ? ', ' : ''
                        }`
                    );
                });
            }
        }

        const itemOffersTakeawayOnly = () =>
            shippingOptions.length === 1 &&
            shippingOptions.find(
                (shippingOption) => shippingOption.shippingType === 'Takeaway'
            ) !== undefined
                ? true
                : false;
        const getCheapestShippingCost = () =>
            shippingOptions.length === 0
                ? { shippingCost: 0 }
                : shippingOptions.reduce((accumulator, currentValue) => {
                      if (
                          (currentValue.shippingCost <
                              accumulator.shippingCost &&
                              currentValue.shippingType !== 'Takeaway') ||
                          accumulator.shippingType === 'Takeaway'
                      ) {
                          return currentValue;
                      }
                      return accumulator;
                  });

        return itemOffersTakeawayOnly()
            ? STRINGS.SHIPPING_LABELS.TAKEAWAY
            : formatPrice(getCheapestShippingCost().shippingCost);
    };
};

export const isNormalListViewType = (listViewType) =>
    listViewType === LIST_VIEW_TYPES.NORMAL;
